<div class="modal-template default-modal">
  <form [formGroup]="transactionForm">
    <div class="modal-container">
      <div class="modal-header">
        <div class="title-text">{{ data.startBalance ? ('accounts.openingBalance' | translate) : ('expense.edit' | translate) }}</div>
        <div class="close-modal" (click)="closeModal()">
          <span class="j-icon-cross"></span>
        </div>
      </div>
      <div class="modal-body">
        <div class="content-container">
          <div class="input-container" [ngClass]="{ 'invalid-validation': f.get(['amount']).errors && submittedForm }">
            <label class="dot-label">{{ 'expense.amount' | translate }}</label>
            <ejs-numerictextbox
              #amountTextBox
              class="left-item"
              formControlName="amount"
              min="0"
              [showSpinButton]="false"
              [showClearButton]="false"
              placeholder="0.00"
            ></ejs-numerictextbox>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button-container">
          <button class="btn-template btn-blue dropdown-button"  (click)="saveTransaction()">
            {{ 'button.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
